import * as React from 'react';
import classnames from 'classnames';

import './style.scss';

export interface ICheckboxProps {
  isChecked: boolean;
  id?: string;
  name: string;
  onChange?: (e: any) => void;
  className?: string;
  disabled?: boolean;
  htmlFor?: boolean;
  isIntermediate?: boolean;
  enableLableClick?: boolean;
  dollarSign?: boolean;
}

export default class Checkbox extends React.Component<ICheckboxProps, {}> {
  static defaultProps: ICheckboxProps = {
    name: 'checkbox',
    isChecked: false,
    onChange: null,
    className: '',
    disabled: false,
    htmlFor: true,
    isIntermediate: false,
    enableLableClick: false,
    dollarSign: false,
  };

  onLabelClick = (e) => {
    if (this.props.enableLableClick) {
      this.props.onChange(e);
    }
  };

  render() {
    return (
      <span className={classnames('checkbox-holder', this.props.className)}>
        <input
          id={this.props.id}
          name={this.props.name}
          className={classnames('checkbox__input', {
            intermediate: this.props.isIntermediate,
          })}
          type="checkbox"
          checked={this.props.isChecked}
          onChange={this.props.onChange}
          disabled={this.props.disabled}
        />
        <label
          htmlFor={this.props.htmlFor ? this.props.id : ''}
          className={classnames('checkbox__content', {
            'htmlfor--enabled': this.props.htmlFor,
          })}
          onClick={this.onLabelClick}
        >
          {this.props.children}
          {this.props.dollarSign ? <div className="dollarSignGreen">$</div> : null}
        </label>
      </span>
    );
  }
}
